import React from "react";
import { Pie } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Chart as ChartJS } from "chart.js";

// Register the plugin
ChartJS.register(ChartDataLabels);

const PieChart = ({ data }) => {
  let totalCollectedAmount = 0;
  const colors = [
    "#ca3451",
    "#0073e6",
    "#5cb360",
    "#606c38",
    "#283618",
    "#bc6c25",
    "#219ebc",
    "#ffb703",
    "#fb8500",
    "#780000",
    "#c1121f",
    "#fdf0d5",
    "#3a86ff",
    "#588157",
    "#80ed99",
  ];
  const labelColors = [];
  let i = 0;
  data?.forEach((d) => {
    totalCollectedAmount += d.totalCollectedAmount;
    labelColors.push(colors[i]);
    i++;
  });
  const percentages = data?.map((item) => ({
    location: item.location.name,
    percentage: (
      (item.totalCollectedAmount / totalCollectedAmount) *
      100
    ).toFixed(2),
  }));
  // Extract labels and percentages
  const labels = percentages?.map((item) => item.location);
  const values = percentages?.map((item) => item.percentage);
  // Chart data
  const chartData = {
    labels: labels,
    datasets: [
      {
        data: values,
        backgroundColor: labelColors,
        hoverBackgroundColor: labelColors,
      },
    ],
  };
  // Chart options
  const options = {
    plugins: {
      datalabels: {
        formatter: (value, context) => {
          const dataset = context.chart.data.datasets[0];
          const total = dataset.data.reduce(
            (acc, val) => acc + parseFloat(val),
            0
          );
          const percentage = ((value / total) * 100).toFixed(2);
          return `${percentage}%`;
        },
        color: "#fff",
        font: {
          weight: "bold",
          size: 14,
        },
      },
    },
    maintainAspectRatio: false, // Disable the aspect ratio to apply the height
  };

  return (
    <div>
      <div className='d-flex justify-content-center'>
        <h6 style={{whiteSpace:'nowrap'}}>Percentage Contribution of each collection to the total</h6>
      </div>
      <div style={{ height: "200px", width: "400px" }}>
        {" "}
        {/* Ensure parent container has defined height */}
        <Pie data={chartData} options={options} />
      </div>
    </div>
  );
};

export default PieChart;
